<div fxLayout fxFlexFill fxLayout.lt-md="column">
  <div class="dd__left" fxFlex="256px" fxLayout="column">
    <div>
      <h4
        class="clickable"
        role="button"
        *ngFor="let sb of sidebar"
        [class.ocean]="sb === activeItem"
        (click)="activeItem = sb">
        {{ sb }}
      </h4>
    </div>
    <div fxFlex fxLayoutAlign="end start" fxLayout="column">
      <button
        *ngIf="
          (perms$.hasAccessTo(Features.PERM_MANAGE_RESERVATIONS) | async) &&
          reservations?.length > 0 &&
          reservations[0]?.editing
        "
        mat-flat-button
        class="button__secondary button__small fw"
        (click)="editReservation()">
        Edit Reservation
      </button>
      <button
        *ngIf="perms$.hasAccessTo(Features.PERM_INBOX) | async"
        mat-flat-button
        class="button__primary button__small fw"
        [routerLink]="['/inbox/thread/' + threadUuid]"
        (click)="dialogRef.close()">
        Open Conversation
      </button>
    </div>
  </div>
  <div class="dd__right" fxFlex>
    <ng-container *ngIf="activeItem === 'Guest Insights'">
      <mat-spinner *ngIf="!thread" [diameter]="16"></mat-spinner>
      <sbnb-guest-banner *ngIf="thread" [thread]="thread"></sbnb-guest-banner>
      <sbnb-insights *ngIf="thread" [thread]="thread" [removeBorders]="true"></sbnb-insights>
    </ng-container>

    <ng-container *ngIf="activeItem === 'Reservation Details'">
      <mat-spinner *ngIf="!reservations" [diameter]="16"></mat-spinner>
      <sbnb-booking-details
        *ngIf="reservations && reservations[0]?._links?.extended"
        [extendedApiUrl]="reservations[0]._links?.extended"></sbnb-booking-details>
    </ng-container>

    <ng-container *ngIf="activeItem === 'Conversation'">
      <h3>Latest conversation</h3>
      <div fxLayout="column" *ngIf="messages?.length > 0">
        <sbnb-thread-messages [reservation]="reservations[0]" [messages]="messages"></sbnb-thread-messages>
      </div>
    </ng-container>

    <ng-container *ngIf="activeItem === 'Activity'">
      <h3>Activity</h3>
      <sbnb-activity-feed [threadUuid]="threadUuid" [lite]="true"></sbnb-activity-feed>
    </ng-container>

    <ng-container *ngIf="activeItem === 'Tasks'">
      <h3>Tasks</h3>
      <sbnb-task-list [threadUuid]="threadUuid"></sbnb-task-list>
    </ng-container>
  </div>
</div>
